import { makeStyles } from "tss-react/mui"
import { MAX_EMAIL_LENGTH } from "../../../../../../constants/inputValidationDefaults"
import { Box } from "@mui/material"
import { faUser } from "@fortawesome/pro-regular-svg-icons"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { FormikTextField } from "../../../../forms/Formik"

import type { CheckoutFormValues } from "./takeawayCheckoutLib"
import { TakeawayCheckoutSectionHeader } from "./TakeawayCheckoutSectionHeader"

const useStyles = makeStyles()(() => ({
    fields: {
        display: "flex",
        flexDirection: "column",
        gap: ".75rem",
    },
    field: {
        "& .MuiOutlinedInput-root": {
            borderRadius: ".75rem",
        },
    },
}))

export function TakeawayCheckoutGuestSection() {
    const { classes } = useStyles()

    return (
        <Box>
            <TakeawayCheckoutSectionHeader
                icon={faUser}
                title={
                    <LocalizedStrict id="takeaway-confirm-order-personal-info-title">
                        <span>Personal Information</span>
                    </LocalizedStrict>
                }
            />
            <Box className={classes.fields}>
                <LocalizedStrict
                    id="takeaway-confirm-order-guest-name-label"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField<CheckoutFormValues>
                        name="guestName"
                        fullWidth
                        label="Full Name"
                        placeholder="Your full name:"
                        required
                        className={classes.field}
                    />
                </LocalizedStrict>
                <LocalizedStrict
                    id="takeaway-confirm-order-guest-email-label"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField<CheckoutFormValues>
                        name="guestEmail"
                        maxLength={MAX_EMAIL_LENGTH}
                        fullWidth
                        label="Email"
                        placeholder="Your e-mail:"
                        required
                        className={classes.field}
                    />
                </LocalizedStrict>
                <LocalizedStrict
                    id="takeaway-confirm-order-guest-phone-label"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField<CheckoutFormValues>
                        name="guestPhone"
                        fullWidth
                        label="Phone Number (optional)"
                        placeholder="Your phone number:"
                        className={classes.field}
                    />
                </LocalizedStrict>
            </Box>
        </Box>
    )
}
